<div [formGroup]="identifierForm" id="identifier-form">
	<div formArrayName="identifiers">
		@for (item of items().controls; track item; let i = $index) {
			<div class="ob-grid">
				<div [formGroupName]="i" class="ob-span-9">
					<mat-form-field>
						<mat-label>{{ "i18n.edit_identifier" | translate }}</mat-label>
						<input
							id="identifiers-description-{{ i }}"
							type="text"
							matInput
							formControlName="identifier"
							[class]="(isIdentifierEditionDisabled || (i === 0 && isFirstIdentifierLocked)) ? 'disabled' : ''"
							[readonly]="isIdentifierEditionDisabled || (i === 0 && isFirstIdentifierLocked)"
						/>
						@if (i === 0) {
							<mat-hint>{{ "i18n.hint.first_identifier" | translate }}</mat-hint>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.required) {
							<mat-error>{{ "i18n.error.required" | translate }}</mat-error>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.identifierExists) {
							<mat-error>{{ "i18n.error.identifier_exists" | translate }}</mat-error>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.identifierAndVersionExists) {
							<mat-error>
								{{ "i18n.error.identifier_and_version_exists" | translate }}
							</mat-error>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.anotherPublisher) {
							<mat-error>
								{{ "i18n.error.another_publisher" | translate }}
							</mat-error>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.whitespace) {
							<mat-error>{{ "i18n.error.whitespace_identifier" | translate }}</mat-error>
						}
						@if (identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.errors?.pattern) {
							<mat-error>{{ getPatternErrorMassage(identifierForm.get("identifiers")?.get(i.toString())?.get("identifier")?.value) | async }}</mat-error>
						}
					</mat-form-field>
				</div>
				<div class="ob-span-3 action-button-wrapper">
					@if (i === 0) {
						<button (click)="addControl()" mat-button obButton="secondary" type="button" [disabled]="isIdentifierEditionDisabled">
							<mat-icon svgIcon="plus" class="ob-icon"></mat-icon> {{ "i18n.edit_identifier.add" | translate }}
						</button>
					}
					@if (i > 0) {
						<button (click)="removeControl(i)" mat-button obButton="secondary" type="button" [disabled]="isIdentifierEditionDisabled">
							<mat-icon svgIcon="delete" class="ob-icon"></mat-icon> {{ "i18n.edit_identifier.delete" | translate }}
						</button>
					}
				</div>
			</div>
		}
	</div>
</div>
